module.exports = __webpack_public_path__ + "static/media/prev.64f0c5b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prev.svg
// module id = 910
// module chunks = 1